import { Props as ButtonProps } from "@storeblocks/button";
import React, { forwardRef } from "react";
import {
  OutlinedThemedButton,
  StyledButton,
  TextButton,
  ThemedButtonBase,
} from "./themedButtonStyled";

import { componentClicked } from "Store/analytics/analyticsSlice";
import { useDispatch } from "react-redux";

interface Props extends ButtonProps {
  ref?: any;
  trackId: string;
}

const getVariant = (variant: string | undefined): any => {
  switch (variant) {
    case "contained":
    case "primary":
      return ThemedButtonBase;
    case "outlined":
      return OutlinedThemedButton;
    case "text":
    case "transparent":
      return TextButton;
    case "icon":
      return StyledButton;
    default:
      return ThemedButtonBase;
  }
};

// eslint-disable-next-line react/display-name
export const ThemedButton = forwardRef(
  (
    props: Props,
    ref: React.ForwardedRef<HTMLButtonElement>,
  ): React.ReactElement => {
    const { variant, children, onClick, trackId, as, ...rest } = props;
    const dispatch = useDispatch();
    const Variant = getVariant(variant);

    const handleOnClick = (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ): void => {
      dispatch(componentClicked(trackId));
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <Variant
        variant={variant === "icon" ? variant : undefined}
        ref={ref}
        forwardedAs={as}
        onClick={handleOnClick}
        data-trackid={trackId}
        {...rest}
      >
        {children}
      </Variant>
    );
  },
);
